module.exports = __webpack_public_path__ + "public/img/zhuli.5f5d9f51.png";